import { render, staticRenderFns } from "./DefaultUserAvatar.vue?vue&type=template&id=724aedd0&scoped=true"
import script from "./DefaultUserAvatar.vue?vue&type=script&lang=js"
export * from "./DefaultUserAvatar.vue?vue&type=script&lang=js"
import style0 from "./DefaultUserAvatar.vue?vue&type=style&index=0&id=724aedd0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "724aedd0",
  null
  
)

export default component.exports